"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTreeSofaCreations = void 0;
var _tree = require("./tree");
var getTreeSofaCreations = exports.getTreeSofaCreations = function getTreeSofaCreations() {
  var pricingVersion = (0, _tree.getPricingVersion)();
  return {
    question: 'Que souhaitez-vous faire ?',
    parts: {
      // **********************************************
      // ****************** Assises *******************
      // **********************************************

      crea_assi: {
        name: 'Housse de canapé',
        nameForOrder: 'Housse d’assise',
        label: 'Les assises',
        labelSummary: 'Assises',
        subTypeQuestions: [{
          slug: 'types',
          question: 'De quel type d’assise s’agit-il ?',
          answers: [{
            slug: 'SIMPLE',
            label: 'Coussin',
            labelSummary: 'Type coussin',
            image: 'https://res.cloudinary.com/tilli/image/upload/v1709561549/tilli-core/type_simple.jpg'
          }, {
            slug: 'COMPLEX',
            label: 'Structuré',
            labelSummary: 'Type structuré',
            image: 'https://res.cloudinary.com/tilli/image/upload/v1709561553/tilli-core/type_complex.jpg'
          }]
        }, {
          slug: 'shapes',
          question: 'De quelle forme s’agit-il ?',
          answers: [{
            slug: 'RECTANGLE',
            label: 'Rectangle',
            labelSummary: 'Forme rectangle',
            image: 'https://res.cloudinary.com/tilli/image/upload/v1709561537/tilli-core/forme_rectangle.jpg'
          }, {
            slug: 'ADJUSTED',
            label: 'Ajustée aux accoudoirs',
            labelSummary: 'Forme ajustée aux accoudoirs',
            image: 'https://res.cloudinary.com/tilli/image/upload/v1709561535/tilli-core/forme_ajustee.jpg'
          }, {
            slug: 'UNDEFINED',
            label: 'Je ne sais pas',
            labelSummary: 'Je ne suis pas sûr(e) de la forme'
          }]
        }, {
          slug: 'closings',
          question: 'Quelle type de fermeture souhaitez-vous ?',
          answers: [{
            slug: 'ZIPPROVIDED',
            label: 'Avec une fermeture éclair',
            labelSummary: 'Fermeture éclair'
          }, {
            slug: 'INVISIBLEZIPPROVIDED',
            label: 'Avec un zip invisible',
            labelSummary: 'Zip invisible'
          }]
        }]
      },
      // **********************************************
      // ****************** Dossiers ******************
      // **********************************************

      crea_doss: {
        name: 'Housse de canapé',
        nameForOrder: 'Housse de dossier',
        label: 'Les dossiers',
        labelSummary: 'Dossiers',
        subTypeQuestions: [{
          slug: 'types',
          question: 'De quel type de dossier s’agit-il ?',
          answers: [{
            slug: 'SIMPLE',
            label: 'Coussin',
            labelSummary: 'Type coussin',
            image: 'https://res.cloudinary.com/tilli/image/upload/v1709561549/tilli-core/type_simple.jpg'
          }, {
            slug: 'COMPLEX',
            label: 'Structuré',
            labelSummary: 'Type structuré',
            image: 'https://res.cloudinary.com/tilli/image/upload/v1709561553/tilli-core/type_complex.jpg'
          }]
        }, {
          slug: 'shapes',
          question: 'De quelle forme s’agit-il ?',
          answers: [{
            slug: 'RECTANGLE',
            label: 'Rectangle',
            labelSummary: 'Forme rectangle',
            image: 'https://res.cloudinary.com/tilli/image/upload/v1709561537/tilli-core/forme_rectangle.jpg'
          }, {
            slug: 'ADJUSTED',
            label: 'Ajustée aux accoudoirs',
            labelSummary: 'Forme ajustée aux accoudoirs',
            image: 'https://res.cloudinary.com/tilli/image/upload/v1709561535/tilli-core/forme_ajustee.jpg'
          }, {
            slug: 'UNDEFINED',
            label: 'Je ne sais pas',
            labelSummary: 'Je ne suis pas sûr(e) de la forme'
          }]
        }, {
          slug: 'closings',
          question: 'Quelle type de fermeture souhaitez-vous ?',
          answers: [{
            slug: 'ZIPPROVIDED',
            label: 'Avec une fermeture éclair',
            labelSummary: 'Fermeture éclair'
          }, {
            slug: 'INVISIBLEZIPPROVIDED',
            label: 'Avec un zip invisible',
            labelSummary: 'Zip invisible'
          }]
        }]
      },
      // **********************************************
      // ****************** Structure *****************
      // **********************************************

      crea_cana: {
        name: 'Housse de canapé',
        nameForOrder: 'Housse de canapé',
        label: 'La structure',
        labelSummary: 'La structure du canapé',
        subTypeQuestions: [{
          slug: 'length',
          question: 'Quelle est la longueur de votre canapé ?',
          answers: [{
            slug: 'SEAT1',
            label: 'Fauteuil',
            labelSummary: 'Fauteuil'
          }, {
            slug: 'SEAT2',
            label: '2 places',
            subLabel: 'inférieur à 1m65',
            labelSummary: '2 places - inférieur à 1m65'
          }, {
            slug: 'SEAT3',
            label: '3 places',
            subLabel: 'inférieur à 2m45',
            labelSummary: '3 places - inférieur à 2m45'
          }, {
            slug: 'SEAT4',
            label: '4 places',
            subLabel: 'inférieur à 3m25',
            labelSummary: '4 places - inférieur à 3m25'
          }, {
            slug: 'SEAT5',
            label: '5 places',
            subLabel: 'supérieur ou égal à 3m25',
            labelSummary: '5 places - supérieur ou égal à 3m25'
          }]
        }, {
          slug: 'width',
          question: 'Quelle est la largeur de votre canapé ?',
          answers: [{
            slug: 'SMALL',
            label: 'Inférieur à 81cm',
            labelSummary: 'Largeur inférieure à 81cm'
          }, {
            slug: 'BIG',
            label: 'Supérieur à 81cm',
            labelSummary: 'Largeur supérieure à 81cm'
          }, {
            slug: 'UNDEFINED',
            label: 'Je ne sais pas',
            labelSummary: 'Je ne suis pas sûr(e) de la largeur'
          }]
        }],
        toppingQuestions: [{
          slug: 'links',
          question: 'Souhaitez-vous que la housse soit ornées de liens ?',
          answers: [{
            slug: 'withLinks',
            label: 'Avec liens',
            id: "".concat(pricingVersion, ".crea_cana-supp-1"),
            image: 'https://res.cloudinary.com/tilli/image/upload/v1709561535/tilli-core/avec_liens.jpg'
          }, {
            slug: 'withoutLinks',
            label: 'Sans liens',
            image: 'https://res.cloudinary.com/tilli/image/upload/v1709561543/tilli-core/sans_liens.jpg'
          }]
        }]
      }
    }
  };
};